export enum TransactionType {
    Property,
    OtherServices,
}

export type TransactionListItemResponseDto = {
    id: string;
    date: Date;
    serviceName?: string;
    apartmentName?: string;
    type: TransactionType;
    amount: number;
    currency?: string;
    sign: TransactionSign;
    deductionFromRentRevenue: boolean;
};

export type TransactionListResponseDto = {
    items?: TransactionListItemResponseDto[];
    totalCount: number;
};

export enum TransactionSign {
    Plus = 1,
    Minus = -1,
}

export type TransactionDetailsResponseDto = {
    id: string;
    type: TransactionType;
    date: Date;
    currency?: string;
    serviceName?: string;
    apartmentName?: string;
    amount: number;
    transactionId?: string;
    sign: TransactionSign;
    deductionFromRentRevenue: boolean;
};
